<template>
    <div class="card">
        <div class="card-body">
            <!-- Inicio Tabla -->
            <div class="table-responsive mb-0 mt-2">
                <b-table
                    :items="tableData"
                    :fields="fields"
                    responsive="sm"                              
                    striped
                    hover
                    :busy="isBusy"
                >
                    <!-- Inicio Spinner en estado "ocupado" de la tabla -->
                    <template #table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>
                    <!-- Fin Spinner en estado "ocupado" de la tabla -->

                    <template #cell(rutEmpresa)="row">
                        <a class="pointer" @click="verEmpresa(row.value)">
                            {{ row.value }}
                        </a>
                    </template>
                              
                </b-table>
            </div>
            <!-- Fin Tabla -->
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    data(){
        return{
            isBusy: false,
            tableData: this.$store.getters["rutEmpresa/empresas"],
            fields: [
                {
                key: "rutEmpresa",
                label: "RUT",
                sortable: false,
                },
                {
                key: "nombre",
                label: "Nombre",
                sortable: false,
                },
                {
                key: "direccionFacturacion",
                label: "Dirección de facturación",
                sortable: false,
                },
                {
                key: "comuna",
                label: "Comuna",
                sortable: false,
                },
                {
                key: "ciudad",
                label: "Ciudad",
                sortable: false,
                },
                {
                key: "telefono",
                label: "Teléfono",
                sortable: false,
                },
                {
                key: "giro",
                label: "Giro",
                sortable: false,
                }
            ],
        }
    },
    computed:{
        ...mapState("rutEmpresa", ["empresas"]),
    },
    watch:{
        empresas(){
            this.tableData = this.empresas
        }
    },
    methods:{
        verEmpresa(data) {
            this.$router.push({
                name: "detalleEmpresa",
                params: { id: data }
            });
        },
    }
}
</script>

<style scoped>
.card{
    border-radius: 0 !important;
}
</style>